import React, { useEffect, useState } from 'react';

import "./Propiedad.css";

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PropiedadColumnList } from './PropiedadConstants';
import { fetchGetModuloList } from '../../reducers/moduloSlice';
import PersonaRelacionada from '../persona/PersonaRelacionada';
import Tabs from '../../components/Tabs';

function Propiedad(props) {
    const { propiedadId } = props;

    const [selectedPropiedad, setSelectedPropiedad] = useState();
    const [selectedModule, setSelectedModule] = useState();
    const [modulePermissions, setModulePermissions] = useState([]);
    const [selectedTab, setSelectedTab] = useState('per');


    const moduleData = useSelector((state) => state.propiedad);
    const moduloList = useSelector(state => state.modulo.moduloList);

    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!moduloList || moduloList.length === 0) {
            dispatch(fetchGetModuloList());
        }
    });

    useEffect(() => {
        if (propiedadId) {
            const selPropiedad = moduleData?.propiedadList?.find(ad => ad.id === propiedadId);
            setSelectedPropiedad(selPropiedad);
        }
    }, [propiedadId]);

    const renderItem = (ccl) => {
        return (
            <div className='item' key={`info-item-${ccl.dbname}`}>
                <div className='title'>{t(ccl.label)}</div>
                <div className='content'>{selectedPropiedad[ccl.dbname]}</div>
            </div>
        )
    }

    return (
        <div
            className="modal"
            id={`propiedad_detail_modal`}
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog  modal-xl modal-administrator" >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="backDropModalTitle">{t("propiedad")}: {selectedPropiedad?.nombre}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className='module-info-container'>
                            <div className='module-info-data' >
                                {
                                    selectedPropiedad && PropiedadColumnList().filter(ccl => ccl.form === true).map(ccl => (renderItem(ccl)))
                                }
                            </div>
                            <Tabs tabData={[
                                { icon: <i class='bx bx-face'></i>, label: 'Personas' },
                                { icon: <i class='bx bxs-car'></i>, label: 'Vehiculos' },
                                { icon: <><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" ><path d="M17 14a5 5 0 0 0 2.71-.81L20 13a3.16 3.16 0 0 0 .45-.37l.21-.2a4.48 4.48 0 0 0 .48-.58l.06-.08a4.28 4.28 0 0 0 .41-.76 1.57 1.57 0 0 0 .09-.23 4.21 4.21 0 0 0 .2-.63l.06-.25A5.5 5.5 0 0 0 22 9V2l-3 3h-4l-3-3v7a5 5 0 0 0 5 5zm2-7a1 1 0 1 1-1 1 1 1 0 0 1 1-1zm-4 0a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"></path><path d="M11 22v-5H8v5H5V11.9a3.49 3.49 0 0 1-2.48-1.64A3.59 3.59 0 0 1 2 8.5 3.65 3.65 0 0 1 6 5a1.89 1.89 0 0 0 2-2 1 1 0 0 1 1-1 1 1 0 0 1 1 1 3.89 3.89 0 0 1-4 4C4.19 7 4 8.16 4 8.51S4.18 10 6 10h5.09A6 6 0 0 0 19 14.65V22h-3v-5h-2v5z"></path></svg></>, label: 'Mascotas' }
                            ]} >
                                <PersonaRelacionada propiedad={selectedPropiedad} />
                                <div>Vehiculo, No implementado todavía</div>
                                <div>Mascotas, No implementado todavía</div>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Propiedad;